














import { ICampaign } from '@/galaxy-cruise/api_interface'
import { i18nTranslate } from '@/i18n'
import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop({ required: true })
  campaign!: ICampaign

  get s() {
    return this.campaign
  }

  imageIndex = this.maxNum - 1

  snowmanImage(imageIndex: number): string {
    const img = this.s.medals[imageIndex].image
    if (this.s.i18n) {
      return i18nTranslate(img as {})
    }
    return img as string
  }

  get maxNum() {
    for (let i = 0; i < this.s.medals.length; ++i) {
      const m = this.s.medals[i]
      if (this.s.count < m.count)
        return i
    }
    return this.s.medals.length
  }
}
